import Loader from "../../../../shared/components/Loader";
import TextBox from "../../../../shared/components/TextBox";
import { ACTION_LABEL, LABELS } from "../../../../shared/constants";

const UserDetail = (props: any) => {
  const { userDetailData, getUserLoading } = props;

  return (
    <>
      {!getUserLoading && userDetailData ? (
        <div className="row">
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.FULLNAME_TEXT}
                placeholder={LABELS.FULLNAME_TEXT}
                name={ACTION_LABEL.NAME}
                value={userDetailData.name}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.EMAIL_TEXT}
                placeholder={LABELS.EMAIL_TEXT}
                name={ACTION_LABEL.EMAIL}
                value={userDetailData.email}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.PHONE_TEXT}
                placeholder={LABELS.PHONE_TEXT}
                name={ACTION_LABEL.PHONE}
                value={userDetailData.phone}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.DESIGNATION_TEXT}
                placeholder={LABELS.DESIGNATION_TEXT}
                name={ACTION_LABEL.DESIGNATION}
                value={userDetailData.designation}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.STATE_TEXT}
                placeholder={LABELS.STATE_TEXT}
                name={ACTION_LABEL.STATE}
                value={userDetailData.state}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.CITY_TEXT}
                placeholder={LABELS.CITY_TEXT}
                name={ACTION_LABEL.CITY}
                value={userDetailData.city}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.ADDRESS_TEXT}
                placeholder={LABELS.ADDRESS_TEXT}
                name={ACTION_LABEL.ADDRESS}
                value={userDetailData.address}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.ROLE_TEXT}
                placeholder={LABELS.ROLE_TEXT}
                name={ACTION_LABEL.ROLE}
                value={userDetailData.role}
                disable
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-2">
              <TextBox
                label={LABELS.STATUS_TEXT}
                placeholder={
                  userDetailData.isActive
                    ? LABELS.ACTIVE_NAME_TEXT
                    : LABELS.INACTIVE_NAME_TEXT
                }
                name={ACTION_LABEL.ISACTIVE}
                value={
                  userDetailData.isActive
                    ? LABELS.ACTIVE_NAME_TEXT
                    : LABELS.INACTIVE_NAME_TEXT
                }
                disable
              />
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default UserDetail;
